<template>
<div class="pmtdiv">
    <smallbutton :toplabel="name" @click="Show()" v-if="showButton" :buttonclass="buttonClass"/>

    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                
                <label class="titlelabel">{{name}}</label>
                <br/>
                
                    <div :class="itemclass(li)" v-for="li in fireableItems" :key="li.id" :value="li.id" @click="toggle(li)" >
                        <div class="vertFlex leftjustify">
                            
                            <div class="horizFlex">
                                <label class="prodlabel" for>{{productName(li)}}</label>
                                <img src="@/assets/fire.png" class="fireimg" v-if="li.isInKitchen"/>
                            </div>
                            <label class="prodsublabel" v-if="li.productOptionsString!=null">{{ li.productOptionsString }}</label>
                            <label class="prodsublabel" v-if="li.optionNote!=null">{{ li.optionNote }}</label>
                        </div>
                    </div>        
                
                <smallbutton  @click="go()" toplabel="Send To Kitchen" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from '../controls/actionmodal.vue'
import confirm from '../actions/confirm.vue'
import pos from '../../services/pos.js'
import pos_culinary from '../../services/pos_culinary.js'
import printreceipthelper from '../../services/printreceipthelper.js'
export default {
    name:'tokitchen',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        confirm
    },
    props:{
      
        showButton:{
            type:Boolean,
            default:false
        },


        buttonClass:{
            type:String,
            default:'button buttonprimary bottom10'
        }
        
    },
    mixins:[pos_culinary,printreceipthelper,pos],
    data(){
        return{
            trueParam:true
        }
    },
    computed:{
        ...mapFields([
            'responseMessage',
            'pleaseWait',
            'ticket'

 
        ]),
        name(){
           return 'Select Items to Send Items to Kitchen'
        },
        fireableItems(){
            var fireable =[]
                let temp = this.ticket.lineItems;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.productIsFireable)
                    })
                }
                
                return temp
            
        }
    },
    methods:{
        toggle(li){
            console.log('ink ' + li.isInKitchen)
            
            if(!li.isInKitchen){
                li.TOSendToKitchen=!li.TOSendToKitchen
            }
        },
        itemclass(g){
           let c = "lineitem panel-inner"
            if(g.TOSendToKitchen){
              c=c+" color-highlight"
            }else if(g.isInKitchen){
              c=c+ " color-disabled"
            
            }else{c=c+" color-inner"}
            return c
        },
        productName(li){
            var name=li.productName
            
            return name
        },
       itemSelected(){
        var selected=false
        this.fireableItems.forEach(myFunction2)
        function myFunction2(item, index, arr) {
                    let li=arr[index]
                    //console.log('pstring ' + li.productPrepAreaString)
                    if(li.TOSendToKitchen){
                        selected=true
                    }
                } 
        return selected
       },
        Show(){
            this.$refs.mymodal.openModal()

        },
        
        async go(){
            if(!this.itemSelected()){
                this.responseMessage="Please select at least one item to send to the kitchen"
                return
            }
            await this.printme()
            this.sendItemsToKitchen()
            this.$emit('refresh')
            this.$refs.mymodal.closeModal()
        },
        async printme(){
                this.receiptPrintJob = await this.printTicketDirect(-1,true)
                this.printReceiptDirect(this.receiptPrintJob)
            },
    }
}

</script>

<style>
.lineitem{

}
.color-disabled{
    background-color: lightgray;
}
.prodlabel{
    font-size:larger;
}
.prodsublabel{
    margin-left:10px;
}
</style>





























